// extracted by mini-css-extract-plugin
export default {"zoomModal":"E0-z","image":"F0-z","button":"G0-z","isOverlayShown":"H0-z"};